import '../styles/input-fields.css';

export class InputFieldProps
{
	width ?: number;
	height ?: number;
	label ?: string;
	onSubmit ?: any;
	boxClass ?: string;
}

export function InputField(props: InputFieldProps) {
	const boxClass : string = props.boxClass !== undefined ? props.boxClass : 'input-box';
	const width : number = props.width !== undefined ? props.width : 256;
	const height : number = props.height !== undefined ? props.height : 16;
	return (
		<div className='input-line'>
			{
				props.label !== undefined 
					? <p className='input-label'>{props.label}</p>
					: null
			}
			<input className={boxClass}></input>
			{
				props.onSubmit !== undefined
					? <button onClick={props.onSubmit} className='input-button'>Submit</button>
					: null
			}
		</div>
	);
}